import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuDivider} from 'mui-tiptap';

const StyledEditorMenuDivider = styled(MenuDivider)`
  ${ComponentStyles}
`;

StyledEditorMenuDivider.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuDivider;
